import { isEqual } from 'lodash';

export function deepEqual(obj1, obj2) {
  const isObjectsEqual = isEqual(obj1, obj2);
  return isObjectsEqual
}